import { ContentChildren, Directive, Input } from "@angular/core";

@Directive({
    selector: 'cec-toolbar>cec-toolbar-item, cec-toolbar-item>cec-toolbar-item',
    standalone: true
})
export class ToolbarItemDirective {

    @Input()
    public id = '';

    @Input()
    public position: 'left' | 'right' = 'right';

    @Input()
    public type: 'button' | 'menu' = 'button';

    @Input()
    public icon = '';

    @Input()
    public tooltip = '';

    @Input()
    public visible = false;

    /** Defines toolbar items in HTML */
    @ContentChildren(ToolbarItemDirective)
    public items: ToolbarItemDirective[] = [];
}